import { TextConfigurationItem } from '../types-store';

const customerSpecificTexts = 10;
const maxDevelopTextSetId = 50000;

export const isCustomerTextSet = (textItem: TextConfigurationItem) =>
  textItem?.textSet?.value === customerSpecificTexts ||
  textItem?.textSet?.value > maxDevelopTextSetId;
